import React from 'react';
import ReactMarkdown from 'react-markdown';
import {Container, Typography, Paper, Box} from '@mui/material';
import UserDanceTable from "../users_list/UserDanceTable";

const PdContent = `
# СОГЛАШЕНИЕ ОБ ИСПОЛЬЗОВАНИИ COOKIE  
## РОО "Рок-н-ролл Джокер"

---

### 1. Общие положения

1.1. Настоящее Соглашение регулирует порядок использования файлов cookie на сайте РОО "Рок-н-ролл Джокер" (далее — Организатор).  

1.2. Cookie-файлы — это небольшие фрагменты данных, которые сохраняются на устройстве пользователя и используются веб-сайтом для распознавания пользователя и предоставления доступа к функционалу.

1.3. Организатор использует cookie **исключительно для целей авторизации и аутентификации пользователей**, а именно:  
- Для сохранения сессии пользователя при входе в личный кабинет;  
- Для обеспечения безопасности и предотвращения несанкционированного доступа.  

--- 

### 2. Категории используемых cookie

2.1. **Обязательные cookie**  
Файлы cookie, необходимые для корректной работы сайта и его функций. Без этих файлов невозможно выполнение базовых действий, таких как вход в систему.

2.2. Аналитические, рекламные и иные cookie **не используются**.

---

### 3. Согласие на использование cookie

3.1. Продолжая использовать сайт, пользователь подтверждает своё согласие на использование технически необходимых cookie-файлов.  

3.2. Если пользователь не согласен с использованием таких cookie, он должен прекратить использование сайта или отключить cookie в настройках браузера, при этом функциональность авторизации может быть ограничена.

---

### 4. Защита данных

4.1. Cookie-файлы не используются для сбора персональных данных или передачи информации третьим лицам.

4.2. Все данные, обрабатываемые с использованием cookie, защищаются в соответствии с [Политикой обработки персональных данных](/pd) Организатора и действующим законодательством РФ.

---

> Актуальная версия данного Соглашения размещена на сайте Организатора: [https://competition.rockandroll.ru/pd_cookie](/pd_cookie)


`;

const Pd = () => {
    return (
        <Box  sx={{
            overflow: 'auto',
            width: '100%',
            mt: 0,
            p: 5,
            background: '#80808040',
            height: (window.innerHeight - 50) + 'px'
        }}>
            <ReactMarkdown>
                {PdContent}
            </ReactMarkdown>
        </Box>
    );
};

export default Pd;